<template>
  <div
    class="flex flex-col items-center w-40 bg-grey-1 rounded border border-grey-5 shadow-md px-4 py-2 m-2"
  >
    <img :src="emote.url" class="admin-emote" />
    <div class="w-full text-center text-blue-7 mt-2">{{ emote.name }}</div>
    <div class="w-full flex justify-between text-sm">
      <div>{{ emote.owner }}</div>
      <button
        class="cursor-pointer text-yellow-8 hover:text-yellow-6 transition-250 transition-color"
        @click="show.delete = true"
      >
        <trash-icon></trash-icon>
      </button>
    </div>

    <portal to="modal-portal">
      <prompt v-if="show.delete" @close="show.delete = false" @confirm="deleteEmote">
        This will delete {{ emote.name }}. This cannot be undone.
        <br />Are you sure?
      </prompt>
    </portal>
  </div>
</template>

<script>
import { TrashIcon } from "vue-feather-icons"

export default {
  name: "EmoteItem",
  props: {
    emote: {
      required: true
    }
  },
  components: {
    TrashIcon
  },
  data() {
    return {
      show: {
        delete: false
      }
    }
  },
  methods: {
    deleteEmote() {
      this.show.delete = false
      this.$api.emotes
        .destroy(this.emote.name)
        .then(() => {
          this.$toasted.success('Emote deleted.')
          this.$parent.fetch()
        })
        .catch(() => {
          this.$error.generic()
        })
    }
  }
}
</script>


<style lang="scss" scoped>
.admin-emote {
  width: 32px;
  height: 32px;
}
</style>

